import Cookies from 'js-cookie'

import {
  updateUser,
  showUser,
  getTimeZone,
  checkStartMeeting
} from '@/api/frontend'

const companies = {
  state: {
    currentUser: (Cookies.get('currentUser')) ? JSON.parse(Cookies.get('currentUser')) : {},

  },
  mutations: {


  },
  actions: {
    /**
     * Get all compainies list 
     * @param {*} param0 
     * @param {*} users 
     * @param {*} id 
     */
    UpdateUserProfile({
      commit
    }, users) {
      return new Promise((resolve, reject) => {
        updateUser(users).then(response => {
          if (response.data.data) {
            commit('SET_USER', response.data.data)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     *
     *  showCompanyProfile    method  for show company profile data     **/

    ShowUserProfile({
      commit
    }, $id) {
      return new Promise((resolve, reject) => {
        showUser($id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * add setting slots  on company setting list
     *  @param {*} slot
     */
    GetTimeZone({
      commit
    }) {

      return new Promise((resolve, reject) => {
        getTimeZone().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     *
     *  showCompanyProfile    method  for show company profile data     **/

    CheckStartMeeting({
      commit
    }, $id) {
      return new Promise((resolve, reject) => {
        checkStartMeeting($id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

  },
}

export default companies
